export const safe = (func: () => any) => {
  try {
    func();
  } catch (error) {
    console.error(error);
  }
};
